import { AxiosInstance } from "axios";
import { BaseUrl } from "./AuthApi";
import { axiosClient } from "./AxiosClient";

export const apiInstance: AxiosInstance = axiosClient(BaseUrl);
